module.exports = __webpack_public_path__ + "static/media/este.0297c2dd.jpg";